/* no-undef */
/* no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { InputWrapperNew, StyledModalNew, StyledBodyNew, StyledHeaderNew, ContainerNew, StyledInputNewP1, InputContainerNew, SubmitContainerNew, NewEmployeeFieldsNew, InputLabelField, SendInviteButton, ButtonsContainer, ActionButton } from './styles';
//import { UserButtonNew } from '../EngagementSection/styles';
import { isValidEmail } from '../../utils/methods';
import { withTranslation } from 'react-i18next';
import CSVList from '../PeopleHomeV2/CSVList';
import { PeoplePageDeleteIcon, UploadHDMIcon } from '../../utils/icons';
// import { PeoplePageDeleteIcon, UploadHDMIcon } from '../../utils/icons';


class NewEmployeePopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popupMode:this.props.popupMode,
      data: [
        {
          fname: '',
          mail: ''
        }
      ],
      file: '',
      csvUpload: false,
      fileName: '',
      showPopUp: false,
      printSampleBiometricCSV:false,
    }
  }

  componentDidMount() {
    this.setState({
      popupMode:this.props.popupMode,
      file: '',
      data: [
        {
          fname: '',
          mail: ''
        }
      ],
      csvUpload: false,
      fileName: ''
    })
  }

  getCSVHeaders = () => {

    const csvHeaders = [
      { label: "First Name", key: "fname" },
      { label: "Last Name", key: "lname" },
      { label: "Email", key: "user_email" },
    ];
  
    return csvHeaders;
  };

  handleFiles = (e) => {
    this.setState({
      file: '',
      fileName: '',
      csvUpload: false,
    })
    let file = e.target.files[0];
    this.setState({
      file: file,
      fileName: file?.name,
      csvUpload: true, 
    });
    let reader = new FileReader();
    reader.readAsDataURL(file);
    const array = document.getElementById('new-employee-file').value.split("\\");
    let checkCSV = array[array.length -1].split('.');
    if(checkCSV[checkCSV.length -1] == 'csv') {
      reader.onloadend = () => {
        this.setState({
          file: reader.result ? reader.result : 'data:',
          fileName: array[array.length - 1],
          csvUpload: true,
          data: [
            {
              fname: '',
              lname: '',
              mail: ''
            }
          ]
        });
      }
    }
    else {
      toast.error('Please select .csv format only');
      document.getElementById('new-employee-file').value = '';
    }
  }
  
  onChangeInput = (e, index) => {
    const duplicateData  = this.state.data;
    duplicateData[index][e.target.name] = e.target.value;
    this.setState({
      data: duplicateData,
      csvUpload: false,
      fileName: '',
      file: ''
    })    
  }

  preventSpecialChars = (e) => {
    const regex = /^[a-zA-Z\s]$/; // allow alphabets + space
  
    if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
      e.preventDefault(); // Block invalid input
    }
  };

  deleteCSV = () => {
    document.getElementById('new-employee-file').value = '';
    this.setState({
      csvUpload: false,
      fileName: '',
      file: ''
    }, () => {
      this.setState({
        csvUpload: false,
        fileName: '',
        file: ''
      })
    })
  }

  showInputContainer = () => {
    const { data } = this.state;
    return data.map((details, index) => (
      <ContainerNew key={index} isNewEmployeePopup>
        <InputContainerNew isNewEmployeePopup>
          <NewEmployeeFieldsNew isNewEmployeePopup>
            <div>
              <InputLabelField isNewEmployeePopup>{this.props.t("First Name")}</InputLabelField>
              <StyledInputNewP1 
                isBg 
                isNewEmployeePopup
                type="text" 
                placeholder={this.props.t('Enter first name')} 
                name='fname' value={details.fname}
                onChange={(e) => this.onChangeInput(e, index)}
                onKeyDown={(e) => this.preventSpecialChars(e)}
              />
            </div>
            <div>  
              <InputLabelField  style={{marginTop: "20px"}} isNewEmployeePopup>{this.props.t("Last Name")} </InputLabelField>
              <StyledInputNewP1 
                isBg 
                isNewEmployeePopup
                type="text"
                placeholder={this.props.t('Enter last name')} 
                name="lname"  
                value={details.lname} 
                onChange={(e) => this.onChangeInput(e, index)}
                onKeyDown={(e) => this.preventSpecialChars(e)}
              />
            </div>
            <div>  
              <InputLabelField style={{marginTop: "20px"}} isNewEmployeePopup>{this.props.t("Email Address")}</InputLabelField>
              <StyledInputNewP1  isBg isNewEmployeePopup type="text" placeholder={this.props.t('Enter email address')} name='mail' value={details.mail} onChange={(e) => this.onChangeInput(e, index)}/>
            </div>
           
          </NewEmployeeFieldsNew>
        </InputContainerNew>
      </ContainerNew>
    ));
     
  }
    

  addEmployeeInputContainer = () => {
    const duplicateData  = this.state.data;
    
    const obj = {
      fname: '',
      lname: '',
      mail: ''
    }
    duplicateData.push(obj);
    this.setState({
      data: duplicateData
    })
  }

  checkErrorMessage = () => {
    let result = {};
    result['errMessage'] = '';
    result['err'] = false;
    let i = 0;
    while(i<this.state.data.length){
      if(i>0 && this.state.data[i].fname.trim() == '' && this.state.data[i].mail.trim() == '') {
        i += 1;
      }
      else if(this.state.data[i].fname.trim() == '') {
        result['errMessage'] = this.props.t("First name can't be blank");
        result['err'] = true;
        i = this.state.data.length;
      }
      else if(this.state.data[i].mail.trim() == ''){
        result['errMessage'] = this.props.t("Email can't be blank");
        result['err'] = true;
        i = this.state.data.length;
      }
      else if(!isValidEmail(this.state.data[i].mail.trim())) {
        result['errMessage'] = this.props.t('Enter valid email');
        result['err'] = true;
        i = this.state.data.length;
      }
      else {
        i += 1;
      }
    }
    return result;
  }

  addEmployeeButton = () => {
    const { companyId, showModalPopUp, postAddEmployee, companyAuthDetails,  } = this.props;
    const { file, data } = this.state;


    if(companyAuthDetails && companyAuthDetails.length && companyAuthDetails[0].password) {
      let obj = {};
      obj['company_id'] = companyId;
      obj['company_password'] = companyAuthDetails[0].password;

      if(file && file.length > 0) {
        obj['csv_file'] = file;
        obj['file_status'] = 1;
        postAddEmployee(obj);
        this.setState({
          file: '',
          data: [
            {
              fname: '',
              lname: '',
              mail: ''
            }
          ],
          csvUpload: false,
          fileName: ''
        })
        showModalPopUp();
      }
      else {
        let result = this.checkErrorMessage();

        if(result['err']) {
          toast.error(result['errMessage']);
        }
        else {
          obj['file_status'] = 0;
          obj['employees'] = data;
          postAddEmployee(obj);
          this.setState({
            file: '',
            data: [
              {
                fname: '',
                lname: '',
                mail: ''
              }
            ],
            csvUpload: false,
            fileName: '',
          })
          showModalPopUp();
        }
      }      
    }
    else {
      toast.error('Company Password Required')
    }
  };
  addEmployeePopUp = () => {
    this.setState({
      showPopUp: !this.state.showPopUp,
    });
  };

  printAction = (bool) => {
    this.setState({printSampleBiometricCSV:bool});
  }

  


  render() {
    const { show } = this.props;
    const { fileName, csvUpload, printSampleBiometricCSV,popupMode } = this.state;
    
    return(
      <>

        <StyledModalNew isNewEmployeePopup show={show} onHide={() => {this.props.showModalPopUp(); this.setState({data: [{
          fname: '',
          lname: '',
          mail: ''
        }], fileName: '', csvUpload: '', file: ''})}} >
          <StyledHeaderNew closeButton>
            <ContainerNew style={{flexWrap:"wrap", flexDirection:"row"}}>
              <div className="headerName">
                {this.props.t("Add New User")}
              </div>
              
              <div className="cross_img">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" style={{ cursor: "pointer" }}
                  onClick={() => {
                    this.props.showModalPopUp(); 
                    this.setState({
                      data: [{
                        fname: '',
                        lname: '',
                        mail: ''
                      }], 
                      fileName: '', 
                      csvUpload: '', 
                      file: ''
                    })
                  }}>
                  <path d="M7.9047 7.0001L13.8421 0.952766C14.0871 0.703686 14.0423 0.336191 13.7427 0.132027C13.4431 -0.0709698 13.0028 -0.035387 12.7578 0.21486L7.0003 6.07903L1.2421 0.214276C0.996403 -0.0359703 0.556103 -0.0715531 0.257203 0.131444C-0.0423974 0.336191 -0.0864976 0.703103 0.157803 0.952183L6.0959 7.0001L0.158503 13.0474C-0.0864974 13.2965 -0.0416975 13.664 0.257903 13.8682C0.388103 13.9563 0.544203 14 0.700303 14C0.903303 14 1.1042 13.9271 1.2428 13.7859L7.0003 7.92117L12.7585 13.7853C12.8971 13.9265 13.098 13.9994 13.301 13.9994C13.4571 13.9994 13.6132 13.9563 13.7434 13.8676C14.043 13.6628 14.0871 13.2959 13.8428 13.0468L7.9047 7.0001Z" fill="#F37A65"/>
                </svg>
                 
              </div>
              
            </ContainerNew>
            
          </StyledHeaderNew>
          
          <StyledBodyNew>
            {popupMode === "manual" ? (
              <>
                {this.showInputContainer()}
                <ContainerNew>
                  <SubmitContainerNew style={{
                    display: 'flex',
                    height: '40px',
                    padding: '12px 16px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '8px',
                    alignSelf: 'stretch',
                    background: '#F37A65',
                    borderRadius: '4px'
                  }}>
                    <SendInviteButton isNewEmployeePopup onClick={this.addEmployeeButton} >
                      {this.props.t("Send Invite")}
                    </SendInviteButton>
                  </SubmitContainerNew>
                  <ButtonsContainer isNewEmployeePopup>
                    <ActionButton 
                      isNewEmployeePopup
                      onClick={this.addEmployeeInputContainer}
                    >
                      {this.props.t("Add more employee")}
                    </ActionButton>
                    <ActionButton 
                      isNewEmployeePopup
                      onClick={() => {
                        // this.props.showModalPopUp();
                        this.setState({popupMode:'bulk'})
                        // this.props.onSwitchMode("bulk");
                      }}
                    >
                      {this.props.t("Switch to bulk upload")}
                    </ActionButton>
                  </ButtonsContainer>
                </ContainerNew>
              </>
            ) : (
              <>
                
                <ContainerNew>
                  
                
                  {/* Divider */}
                  <div style={{ width: '100%', borderBottom: '1px solid #E0E0E0', margin: '16px 0' }} />
                
                  {/* Description */}
                  <div className="uploadText">
                    {this.props.t("Upload CSV file to add employees")}
                  </div>
                
                  
                  <div
                    className='uploadCSV'
                  >
                      
                    <span>
                      {UploadHDMIcon(16,20)}
                    </span>
                    
                    <InputWrapperNew htmlFor="new-employee-file" bgColor={'none'} Color={'none'}>
                      <span>{this.props.t("Upload CSV Now")}</span>
                      <input
                        id="new-employee-file"
                        type="file"
                        name="user"
                        style={{ display: 'none' }}
                        multiple={false}
                        onChange={(e) => { this.handleFiles(e)}}
                        onClick={(e) =>{ e.target.files[0] && this.handleFiles(e);}}
                        accept=".csv"
                      />  
                    </InputWrapperNew>
   
                    
                    
                  </div>
                  { csvUpload && 
                <div className="SuccessUpload" style={{ display:'flex',padding:"12px 16px"}}>
                  <div className="deleteIcon" aria-hidden="true" onClick={this.deleteCSV} style={{paddingRight:"5px", cursor:"pointer"}}>{PeoplePageDeleteIcon()}</div>
                  <div style={{color:"#184A61",fontFamily:"Lato",fontSize:"16px"}}>{fileName}</div> 
                </div>}
                
                  
                  <SendInviteButton
                    isNewEmployeePopup
                    disabled={!this.state.csvUpload}
                    csvReady={this.state.csvUpload}
                    onClick={this.addEmployeeButton}
                    
                    style={{
                      width: "100%",
                      height: 40,
                      padding: "12px 16px",
                      background: this.state.csvUpload ? "#F37A65" : "#EFEFEF",
                      color: this.state.csvUpload ? "#fff" : "#A0A0A0",
                      border: "none",
                      borderRadius: "4px",
                      fontWeight: 400,
                      fontSize: "16px",
                      marginTop: 10,
                      lineHeight: "20px",
                      gap: 8,
                      
                      
                    }}
                  >
                    {this.props.t("Send Invite")}
                  </SendInviteButton>
                
                  
                  <ButtonsContainer isNewEmployeePopup>
                    <ActionButton
                      isNewEmployeePopup
                      onClick={()=>this.setState({printSampleBiometricCSV:true})}
                      
                    >
                      {this.props.t("Download Sample")}
                    </ActionButton>
                    <ActionButton
                      isNewEmployeePopup
                      onClick={() => {
                        // this.props.showModalPopUp();
                        this.setState({popupMode:'manual'})
                        // this.props.onSwitchMode("manual");
                      }}
                      
                    >
                      {this.props.t("Manual Upload")}
                    </ActionButton>
                  </ButtonsContainer>
                </ContainerNew>           
              </>
            )}
          </StyledBodyNew>
        </StyledModalNew>
        {printSampleBiometricCSV && <CSVList Title={`${"Sample file"}`} removeCSVData={this.printAction} headers={this.getCSVHeaders()} data={[]} />}
      </>
      
    );
  }
}

NewEmployeePopup.propTypes = {
  show: PropTypes.bool,
  showModalPopUp: PropTypes.func,
  postAddEmployee: PropTypes.func,
  companyId: PropTypes.number,
  companyAuthDetails: PropTypes.func,
  t: PropTypes.func,
  fetchInactiveUsersList: PropTypes.func,
  inactive : PropTypes.bool,
  companyDetails: PropTypes.func,
  popupMode: PropTypes.string,
  onSwitchMode: PropTypes.func,
  
}

export default ((withTranslation())(NewEmployeePopup));

